import { Component, OnInit } from '@angular/core';
import { BreadcrumbService } from '../../service/breadcrumb.service';
import { SharedDataService } from '../../service/shared-data/shared-data.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss',
})
export class BreadcrumbsComponent implements OnInit {
  breadcrumbs: {
    label: string;
    url?: string;
    type?: string;
  }[] = [];

  constructor(
    private breadcrumbService: BreadcrumbService,
    public sharedDataService: SharedDataService,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.breadcrumbService.breadcrumbs$.subscribe((breadcrumbs) => {
      this.breadcrumbs = breadcrumbs;
      for (let item of this.breadcrumbs) {
        if (item.label === 'Configuration') {
          this.sharedDataService.showDropDown = true; // Set showDropdown flag to true if "Configuration"
          delete item.url; // Remove URL if label is "Configuration"
        } else {
          this.sharedDataService.showDropDown = false; // Hide dropdown for other labels
        }
      }
    });
  }

  public onBreadcrumbClick(breadcrumb: { label: string; url?: string }) {
    if (breadcrumb.label === 'Configuration') {
      // If label is "Configuration", just set the dropdown and do nothing else
      this.sharedDataService.showDropDown = true; // Set showDropdown flag to true
      return; // Prevent navigation and do not modify the breadcrumb list
    } else {
      // If any other breadcrumb is clicked, hide the dropdown
      this.sharedDataService.showDropDown = false;
    }
    if (breadcrumb.label === 'Home') {
      this.sharedDataService.activeTab = breadcrumb.url || '/dashboard';
    }
    // For other breadcrumbs, continue with navigation and trimming breadcrumbs
    this.breadcrumbService.trimBreadcrumbs(breadcrumb.label, breadcrumb.url);
  }
}
